<template>
  <!-- 信息发布 -->
  <div class="page-solicitation">
    <!-- 表头搜索 -->
    <mySearchDict ref="mySearchDict" :showHilever="false" :pageType="`8`" @getParams="getHeadParams"></mySearchDict>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('', 'add')">
            <svg-icon icon-class="add" />&nbsp;新增
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="图片" width="100">
            <template slot-scope="scope">
              <viewer :options="{ url: 'data-maxUrl' }">
                <img class="g-pointer" :src="scope.row.imgUrls &&scope.row.imgUrls[0].attPath  || ''" :data-maxUrl="scope.row.imgUrls &&scope.row.imgUrls[0].attPath" alt :onerror="defaultImg" style="width: 50px;height: 30px;object-fit: contain;">

                <!-- <img class="g-pointer" :src="scope.row.midImgUrl"
                  :data-maxUrl="scope.row.midImgUrl" alt :onerror="defaultImg"
                  style="width: 50px;"> -->
              </viewer>
            </template>

            <!-- <template slot-scope="scope">{{ scope.$index+1 }}</template> -->
          </el-table-column>
          <el-table-column label="藏品编号" min-width="15%">
            <template slot-scope="scope">
              <span>{{scope.row.collectCode}}</span>
              <!-- <span>{{scope.row.code |  filterRang(that)}}</span> -->
            </template>
          </el-table-column>
          <el-table-column label="藏品名称" min-width="15%" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.collectName }}</span>
              <!-- <span class="m-btn" @click="handleAdd(scope.row, 'detail')">{{ scope.row.collectName }}</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="signCode" label="总登记号" min-width="23%"></el-table-column>
          <el-table-column prop="typeCode" label="分类号" min-width="14%">
            <template slot-scope="scope">
              <span>{{scope.row.typeCode}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="collectTypeDes" label="类别" min-width="8%"></el-table-column>
          <el-table-column prop="collectYearDes" label="年代" min-width="20%"></el-table-column>
          <el-table-column prop="collectLevelDes" label="级别" min-width="8%"></el-table-column>
          <!-- <el-table-column prop="creater" label="画册文件?" min-width="8%"></el-table-column> -->
          <el-table-column prop="sequence" label="排序" min-width="8%"></el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="16%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handlePublish(scope.row)">{{ scope.row.status=='2'?'取消发布':'发布' }}</a>

              <!-- <a class="m-btn mr-10" @click="handleAdd(scope.row, 'detail')">查看</a> -->

              <a class="m-btn mr-10" @click="handleEdit('edit', scope.row)">编辑</a>

              <!-- <a class="m-btn mr-10" @click="downLoad(scope.row)">下载</a> -->

              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">删除</a>

              
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialogAdd ref="dialogAdd" @refresh="restList"></dialogAdd>
  </div>
</template>

<script>
import mySearchDict from './my-qinggong-search-dict'
import dialogAdd from './dialog-add'
export default {
  components: {
    mySearchDict,
    dialogAdd
  },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      headParams: {
        collectTexture: '', // 质地类别
        collectDisablity: '', // 完残程度
        source: '', // 藏品来源
        qualityRange: '', // 质量范围
        enterCollectRange: '', // enterCollectRange
        collectType: '', // 藏品分类
        collectYear: '', // 藏品年代
        collectLevel: '', // 藏品级别
        isHigh: '', //是否高清图
      },

      that: this,
      form: {
      },
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      typeList: [],
      tableData: [],
      listLoading: true,
    }
  },
  // filters: {
  //   filterStatus(status) {
  //     if (status == 0) {
  //       return '未发布'
  //     } else if (status == 1) {
  //       return '已发布'
  //     }
  //     return
  //   },
  //   // filterRang(rang, self) {
  //   //   let obj = self.typeList.filter(item => {
  //   //     return item.dictCode == rang
  //   //   })

  //   //   if (obj && obj.length > 0) {
  //   //     return obj[0].dictName
  //   //   }

  //   //   return null
  //   // }
  // },
  methods: {
    // 初始化表格
    initList() {
      this.listLoading = true
      this.tableData = []

      this.$http.get('/qinggong/qgCollect/list', {
        // ...this.form,
        ...this.listQuery,
        // ...this.headParams,

        name: this.headParams.key,
        type: this.headParams.collectType,
        year: this.headParams.collectYear,
        level: this.headParams.collectLevel
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        } else {
          this.$message.error(res.result.message)
        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })
    },

    handleAdd(item, type) {
      this.$refs.dialogAdd.init(item, type)
    },

    handleEdit(type, item) {
      console.log(item)
      this.$router.push({
        path: '/qinggong/edit',
        query: {pageType: type, id: item && item.id}
      })
    },

    // 获取头部参数
    getHeadParams(params) {
      // let f = 1
      // for (let k in params) {
      //   if (params[k]) {
      //     f = 0
      //   }
      // }
      // // 重置排序
      // if (f == 1) {
      //   this.$refs.tableRef.clearSort()
      // }
      this.listQuery.currentPage = 1
      this.headParams = params
      this.initList()
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['volunteer_identity_type', 'volunteer_recruit_status']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.typeList = firstArr.concat(state['volunteer_identity_type'])
            // this.statusList = firstArr.concat(state['volunteer_recruit_status'])
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 下载
    downLoad(item) {
      location.href = '/singleMuseum/collectmaterial/download?id=' + item.id
    },

    // 重置查询
    restList() {
      // this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          content: '该数据将被删除，请谨慎操作'
        }, () => {
          this.$http
            .get('/collectmaterial/delete', {
              id: id
            }).then(res => {
              if (res.success) {
                this.$message.success('删除成功')
                this.initList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    handlePublish(item) {
      this.$http.post('/qinggong/qgCollect/publicOrNot', { 
        id: item.id, 
        status: item.status == '2' ? '1' : '2'  // 2发布1取消发布
      }).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.initList()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // handleCreate(type, id) {
    //   this.$refs.dialogCreateInfo.init(type, id)
    // },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },
  created() {
    this.initList()
    // this.getDropdownValue()

    // window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.page-solicitation {
  width: 100%;
}
.el-form-state {
  /deep/ .el-form-item__label {
    width: 80px !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 80px !important;
  }
}
</style>